module.exports = __webpack_public_path__ + "img/08-password.6ae7b43c.png";